mutation deleteSocialMediaPosts($input: DeleteSocialMediaPostsInput!) {
  deletedSocialMediaPosts: deleteSocialMediaPosts(input: $input)
}
